"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var yaml_ast_parser_1 = require("@stoplight/yaml-ast-parser");

exports.safeStringify = function (value, options) {
  return typeof value === 'string' ? value : yaml_ast_parser_1.safeDump(value, options);
};